import IAmount from "./IAmount";
import IOperatingLeaseItem from "@/module/main/dto/IOperatingLeaseItem";
import OperatingLeaseItemType from "@/module/main/dto/OperatingLeaseItemTypeEnum";
import GoodsType from "@/module/main/dto/GoodsTypeEnum";
import GoodsQuality from "@/module/main/dto/GoodsQualityEnum";
import IFileData from "@/module/main/dto/financing-v3/IFileData";

export default class OperatingLeaseItem implements IOperatingLeaseItem
{
    public readonly type: OperatingLeaseItemType;
    public readonly name: string;
    public readonly code?: string;
    public readonly image?: IFileData;
    public readonly producer?: string;
    public readonly totalPrice?: IAmount;
    public readonly totalPriceWithoutVat?: IAmount;
    public readonly goodsType?: GoodsType;
    public readonly quality?: GoodsQuality;

    constructor(props: IOperatingLeaseItem)
    {
        this.type = props.type;
        this.name = props.name;
        this.code = props.code;
        this.image = props.image;
        this.producer = props.producer;
        this.totalPrice = props.totalPrice;
        this.totalPriceWithoutVat = props.totalPriceWithoutVat;
        this.goodsType = props.goodsType;
        this.quality = props.quality;
    }
}
